export default __webpack_public_path__ + "static/media/2.5c81b792.png";